import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import {
  GraphicsInfo,
  GraphicsInfoColorField,
  GraphicsInfoScaleField,
  GraphicsInfoPositionField,
  GraphicsInfoTextField,
  GraphicsInfoMediaField,
} from "../../../domain/graphics-info";

@Component({
  selector: "icn-edit-graphics-main",
  templateUrl: "./edit-graphics-main.component.html",
  styleUrls: ["./edit-graphics-main.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditGraphicsMainComponent {
  @Input()
  defaultView = true;

  @Input()
  graphicsInfo: GraphicsInfo;

  @Input()
  isDynamicPromoGraphicInstance = false;

  showDurationField() {
    if (
      isFinite(this.graphicsInfo.startLoopMS) &&
      isFinite(this.graphicsInfo.endLoopMS)
    ) {
      return true;
    }
    return false;
  }

  getColorFields(): GraphicsInfoColorField[] {
    return this.graphicsInfo.fields
      .filter((field) => field instanceof GraphicsInfoColorField)
      .map((x) => x as GraphicsInfoColorField);
  }

  getScaleField(): GraphicsInfoScaleField {
    return this.graphicsInfo.fields.find(
      (field) => field instanceof GraphicsInfoScaleField,
    ) as GraphicsInfoScaleField;
  }

  getPositionField(): GraphicsInfoPositionField {
    return this.graphicsInfo.fields.find(
      (field) => field instanceof GraphicsInfoPositionField,
    ) as GraphicsInfoPositionField;
  }

  getTextFields(): GraphicsInfoTextField[] {
    return this.graphicsInfo.fields.filter(
      (field): field is GraphicsInfoTextField => field instanceof GraphicsInfoTextField,
    );
  }

  getMediaFields(): GraphicsInfoMediaField[] {
    return this.graphicsInfo.fields
      .filter((field) => field instanceof GraphicsInfoMediaField)
      .map((x) => x as GraphicsInfoMediaField);
  }

  onDurationChanged(newValue) {
    this.graphicsInfo.durationMS = newValue;
  }

  getDurationValues() {
    if (
      this.graphicsInfo.durationMS &&
      this.graphicsInfo.startLoopMS &&
      this.graphicsInfo.endLoopMS
    ) {
      const res = {
        duration: this.graphicsInfo.durationMS,
        startLoop: this.graphicsInfo.startLoopMS,
        endLoop: this.graphicsInfo.endLoopMS,
        step: null,
      };
      if (res.startLoop != res.endLoop) {
        res.step = res.endLoop - res.startLoop;
      }
      return res;
    }
  }

  zIndexChangedEventHandler(zIndex: number) {
    //console.log('zIndexChangedEventHandler', zIndex);
    this.graphicsInfo.zLayer = zIndex;
  }
}
